var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { toggleMark } from "prosemirror-commands";
import Extension from "../lib/Extension";
var Mark = /** @class */ (function (_super) {
    __extends(Mark, _super);
    function Mark() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Mark.prototype, "type", {
        get: function () {
            return "mark";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Mark.prototype, "markdownToken", {
        get: function () {
            return "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Mark.prototype, "toMarkdown", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Mark.prototype.parseMarkdown = function () {
        return {};
    };
    Mark.prototype.commands = function (_a) {
        var type = _a.type;
        return function () { return toggleMark(type); };
    };
    return Mark;
}(Extension));
export default Mark;
